module.exports = __webpack_public_path__ + "static/img/index1.ab4cf88.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/index1.png
// module id = w/sf
// module chunks = 7